var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownvote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2131_21589)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 35,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 34,
    stroke: "black",
    strokeWidth: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2131_21589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.933 26.793V64.5861H37.0727V59.979L41.2601 61.0759C41.7253 61.2953 42.4232 61.0759 42.6559 60.6371C42.8885 60.1983 42.8885 59.5402 42.6559 59.3208L37.3054 53.3973V38.9177C37.3054 38.479 37.0727 38.2596 36.8401 38.0402L32.1875 34.53L59.933 26.793Z",
    fill: "#E6570E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7314 24.2194C61.2661 24 61.0335 24 60.5682 24L28.9305 32.7755C28.4653 32.9949 28 33.4337 28 33.8724C28 34.3112 28 34.75 28.4653 34.9694L34.5136 39.5765V53.6173C34.5136 53.8367 34.5136 54.2755 34.7463 54.4949L37.7705 58.0051L35.9094 57.5663C35.4442 57.5663 35.2115 57.5663 34.7463 57.7857C34.5136 58.0051 34.281 58.4439 34.281 58.6633V65.9031C34.281 66.5612 34.7463 67 35.4442 67H60.5682C61.2661 67 61.7314 66.5612 61.7314 65.9031V25.0969C61.7314 24.3952 61.7314 24.5 61.7314 24.2194ZM59.6377 64.5867H37.0726V59.9796L41.2599 61.0765C41.7252 61.2959 42.4231 61.0765 42.6557 60.6378C42.8883 60.199 42.8883 59.5408 42.6557 59.3214L37.3052 53.398V38.9184C37.3052 38.4796 37.0726 38.2602 36.8399 38.0408L32.1873 34.5306L59.5 26.852V46L59.6377 64.5867Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7282 39.1369C53.9123 39.1369 55.6829 37.4671 55.6829 35.4073C55.6829 33.3475 53.9123 31.6777 51.7282 31.6777C49.544 31.6777 47.7734 33.3475 47.7734 35.4073C47.7734 37.4671 49.544 39.1369 51.7282 39.1369Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1932 62.3926C51.728 62.3926 51.2627 61.9538 51.2627 61.515C51.2627 60.1987 52.1932 59.3211 52.8911 58.8824C53.589 58.4436 53.8216 58.2242 53.8216 57.566C53.8216 56.9079 53.589 56.6885 52.8911 56.2497C52.1932 55.8109 51.2627 54.9334 51.2627 53.6171C51.2627 52.3007 52.1932 51.4232 52.8911 50.9844C53.589 50.5456 53.8216 50.3263 53.8216 49.6681C53.8216 49.2293 53.589 48.7905 52.8911 48.3518C52.1932 47.913 51.2627 47.0354 51.2627 45.7191C51.2627 44.4028 52.1932 43.5252 52.8911 43.0865C53.589 42.6477 53.8216 42.4283 53.8216 41.7701C53.8216 41.3314 54.2869 40.8926 54.7522 40.8926C55.2174 40.8926 55.6827 41.3314 55.6827 41.7701C55.6827 43.0865 54.7522 43.964 54.0543 44.4028C53.3564 44.8416 53.1237 45.0609 53.1237 45.7191C53.1237 46.1579 53.3564 46.5967 54.0543 47.0354C54.7522 47.4742 55.6827 48.3518 55.6827 49.6681C55.6827 50.9844 54.7522 51.862 54.0543 52.3007C53.3564 52.7395 53.1237 52.9589 53.1237 53.6171C53.1237 54.0558 53.3564 54.4946 54.0543 54.9334C54.7522 55.3722 55.6827 56.2497 55.6827 57.566C55.6827 58.8824 54.7522 59.7599 54.0543 60.1987C53.3564 60.6375 53.1237 60.8569 53.1237 61.515C53.1237 61.9538 52.6585 62.3926 52.1932 62.3926Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6102 62.3932C46.1449 62.3932 45.6797 61.9544 45.6797 61.5157C45.6797 60.1993 46.6102 59.3218 47.3081 58.883C48.006 58.4442 48.2386 58.2249 48.2386 57.5667C48.2386 56.9085 48.006 56.6891 47.3081 56.2504C46.6102 55.8116 45.6797 54.934 45.6797 53.6177C45.6797 52.3014 46.6102 51.4238 47.3081 50.9851C48.006 50.5463 48.2386 50.3269 48.2386 49.6687C48.2386 49.23 48.006 48.7912 47.3081 48.3524C46.6102 47.6942 45.6797 47.0361 45.6797 45.5004C45.6797 44.184 46.6102 43.3065 47.3081 42.8677C47.7734 42.4289 48.006 42.2095 48.006 41.5514C48.006 41.1126 48.4713 40.6738 48.9365 40.6738C49.4018 40.6738 49.867 41.1126 49.867 41.5514C49.867 42.8677 48.9365 43.7453 48.2386 44.184C47.7734 44.8422 47.5407 45.0616 47.5407 45.5004C47.5407 45.9391 47.7734 46.3779 48.4713 46.8167C49.1691 47.2555 50.0997 48.133 50.0997 49.4493C50.0997 50.7657 49.1691 51.6432 48.4713 52.082C47.7734 52.5208 47.5407 52.7402 47.5407 53.3983C47.5407 53.8371 47.7734 54.2759 48.4713 54.7146C49.1691 55.1534 50.0997 56.031 50.0997 57.3473C50.0997 58.6636 49.1691 59.5412 48.4713 59.98C47.7734 60.4187 47.5407 60.6381 47.5407 61.2963C47.5407 61.9544 47.0755 62.3932 46.6102 62.3932Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7985 36.725C51.8264 36.725 52.6596 35.9393 52.6596 34.9699C52.6596 34.0006 51.8264 33.2148 50.7985 33.2148C49.7707 33.2148 48.9375 34.0006 48.9375 34.9699C48.9375 35.9393 49.7707 36.725 50.7985 36.725Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2131_21589",
    x: 0,
    y: 0,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2131_21589"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2131_21589",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2131_21589",
    x: 16,
    y: 16,
    width: 49.7314,
    height: 59,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2131_21589"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2131_21589",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownvote);
export default __webpack_public_path__ + "static/media/downvote.ecdd78a026c725c51f2832352ec85aa0.svg";
export { ForwardRef as ReactComponent };